
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learning/virtual-library",
      function () {
        return require("private-next-pages/learning/virtual-library.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learning/virtual-library"])
      });
    }
  